import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { Broadcast } from "@/api/broadcast/broadcast.types";
import ContentRequests from "@/api/content/content.requests";

import { PlayerUIProvider } from "./PlayerUIContext";
import LivePlayerUI from "./UI/LivePlayerUI";
import { PlayerControlsProvider } from "./hooks/PlayerControlsContext";
import { usePrepareLive } from "./hooks/usePrepareLive";

const BroadcastPlayer = ({ data }: { data?: Broadcast }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  usePrepareLive(videoRef, data?.allowed_subscriptions, data?.link);
  const { id } = useParams() as { id: string };

  useEffect(() => {
    const statisticInterval = setInterval(() => {
      const formData = new FormData();
      formData.append("broadcast_id", id);
      if (!videoRef.current) return;

      if (!videoRef.current.paused) {
        ContentRequests.postContentStatistic(formData);
      }
    }, 10000);
    return () => clearInterval(statisticInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div
      className="relative flex h-full max-h-screen min-h-screen w-full items-center justify-center overflow-hidden bg-black"
      id="player-container"
    >
      <video ref={videoRef} autoPlay className="m-auto max-h-screen w-full !object-contain" />
      <PlayerUIProvider loading={false}>
        <PlayerControlsProvider>
          <LivePlayerUI data={data} videoRef={videoRef} />
        </PlayerControlsProvider>
      </PlayerUIProvider>
    </div>
  );
};

export default BroadcastPlayer;
